// extracted by mini-css-extract-plugin
export default {"status":"Order_status__caFVW","cancelledStatus":"Order_cancelledStatus__fPJ7U"};